import script from "./PcP.vue?vue&type=script&lang=ts&setup=true"
export * from "./PcP.vue?vue&type=script&lang=ts&setup=true"

import "./PcP.vue?vue&type=style&index=0&id=5f601758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f601758"]])

export default __exports__